import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../stateProvider/StateProvider';
import Table from '../../table/Table';
import { generateId, shortHandDateTime } from '../../utility/functions';
import Col from '../../layout/Col';
import Button from '../../forms/Button';
import PageBreak from '../../layout/PageBreak';
import FormSetting from '../../layout/FormSetting';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';
import useDebounce from '../../utility/debounce';
import Row from '../../layout/Row';
import ManagementRow from '../../table/ManagementRow';
import Form from '../../forms/Form';
import ModalFactory from '../../Modal';

const PushNotifications = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();

    const [notification, refreshNotification] = GetState(QuestRoute.notifications.new)

    const [users, setUsers] = useState([])
    const [query, setQuery] = useState('')
    const [searched, setSearched] = useState([])
    const debounced = useDebounce(query, 400)

    useEffect(() => {
        if (debounced.length < 2) {
            setSearched([])
            return
        }

        HamQuest.getQuery(QuestRoute.users, { name: debounced })
            .then(res => {
                if (res.length > 5) {
                    const firstFiveResults = res.slice(0, 5);
                    setSearched(firstFiveResults.filter(e => !users.find(u => u.userId === e.userId)))
                } else {
                    setSearched(res.filter(e => !users.find(u => u.userId === e.userId)))
                }
            })
    }, [debounced])

    const adjustUsers = (user) => {
        const userExists = users.some(u => u.userId === user.userId);
        const newList = userExists
            ? users.filter((u) => u.userId !== user.userId)
            : [...users, user];
        setUsers(newList);
    };

    const deleteNotification = (e) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete this Notification?`,
                type: 'warning',
                closeAfter: true
            },
            promise: {
                title: 'Deleting Product',
                body: `Deleting ${e.name}`,
                callback: () => HamQuest.delete(QuestRoute.notifications.edit(e.id))
            },
            confirmed: {
                title: 'Success',
                body: `Notification successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshNotification()
        })
    }

    const editNotification = (e) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit Notification`,
            body: (
                <Form
                    inputs={{
                        ...e
                    }}
                    onSubmit={e => HamQuest.put(QuestRoute.notifications.edit(e.id), { ...e })
                        .then(() => {
                            refreshNotification();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    <Input
                        label='Notification Title'
                        name='title'
                        required
                    />
                    <Preput
                        label='Notification Body'
                        name='body'
                        required
                    />
                </Form>

            )
        })
    }

    return (
        <PageBreak>
            <FormSetting
                label='Send Push Notification'
                inputs={{
                    title: '',
                    body: '',
                }}
                onSubmit={e => HamQuest.post(QuestRoute.notifications.new, {
                    ...e,
                    userIds: users.map(e => e.userId)
                })
                    .then(() => {
                        refreshNotification();
                        ModalFactory.show({
                            title: 'Sent',
                            body: 'Notification send successfully.'
                        });
                    })}
                text='Send'
            >
                {({ setValue }) => (
                    <>
                        <Input
                            label='Notification Title'
                            name='title'
                            required
                        />
                        <Preput
                            label='Notification Body'
                            name='body'
                            required
                        />

                        <Col style={{ alignItems: 'flex-start' }}>
                            <Input
                                label='Send Targeted Notifications'
                                onInput={e => setQuery(e.target.value)}
                                value={query}
                                standalone
                                placeholder='Search for User'
                            />
                            <Col>
                                {searched
                                    .map(e => (
                                        <Row key={generateId()} style={{ justifyContent: 'space-between' }}>
                                            <span>{e.fullName}</span>
                                            <Button
                                                onClick={() => {
                                                    setQuery('');
                                                    setSearched([]);
                                                    adjustUsers(e);
                                                }}
                                                label='Add User'
                                            />
                                        </Row>
                                    ))}
                            </Col>
                        </Col>
                        {users.length ? (
                            <Col>
                                <span>Sending to: </span>
                                {users.map(e => (
                                    <Row>
                                        <b>{e.fullName}</b>
                                        <Button
                                            onClick={() => adjustUsers(e)}
                                            label='Clear User'
                                        />
                                    </Row>
                                ))}
                            </Col>
                        ) : null}
                    </>
                )}
            </FormSetting>

            <Table
                config={{
                    label: 'Notifications',
                    data: notification,
                    headers: [
                        {
                            label: 'Title',
                            propKey: 'title',
                        }, {
                            label: 'Body',
                            propKey: 'body',
                        }, {
                            label: 'Create Date',
                            propKey: 'createDate',
                        },
                    ],
                    renderFormat: (e) => (
                        <ManagementRow
                            key={generateId()}
                            controls={[
                                <Button key={generateId()} onClick={() => editNotification(e)}>Edit</Button>,
                                <Button key={generateId()} onClick={() => deleteNotification(e)}>Delete</Button>
                            ]}
                        >
                            <td>{e.title}</td>
                            <td>{e.body}</td>
                            <td>{shortHandDateTime(e.createDate)}</td>
                        </ManagementRow>
                    )
                }}
            />
        </PageBreak>
    );
}

export default PushNotifications;